import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ShopAPI } from "../../apis/ShopAPI";
import { Navigate } from "react-router-dom";
import { SectionAPI } from "../../apis/SectionAPI";

const EditSection = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [section, setSection] = useState({
    name: "",
    subcategory_id: null,
  });

  const [loading, setLoading] = useState(true);
  const [shops, setShops] = useState(null);

  const handleInputSection = (e) => {
    setSection({ ...section, [e.target.name]: e.target.value });
  };

  const handleChangeShop = (newShopId) => {
    setSection({
      ...section,
      subcategory_id: newShopId,
    });
  };

  useEffect(() => {
    try {
      ShopAPI.getAll().then((shopsApi) => {
        setShops(shopsApi);
      });
    } catch (error) {
      console.log(error);
    }

    try {
      SectionAPI.get(id).then((section) => {
        setSection({
          name: section.name,
          subcategory_id: section.subcategory_id,
        });
        setLoading(false);
      });
    } catch (error) {
      console.log(error.response.data);
    }
  }, []);

  useEffect(() => {
    handleChangeShop(section.subcategory_id);
  }, [section.subcategory_id]);

  const apiCall = () => {
    try {
      SectionAPI.update(section, id).then(() => {
        navigate("/sections");
      });
    } catch (error) {
      console.log(error.response.data.message);
    }
  };

  return (
    <div>
      {loading ? (
        <div className="flex justify-center items-center h-screen">
          <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-white"></div>
        </div>
      ) : (
        <section className="mt-20">
          <div className="rounded-xl mx-auto max-w-2xl px-4 py-8 lg:py-16 bg-white">
            <h2 className="mb-4 text-xl font-bold justify-center text-gray-900 ">
              Edit section
            </h2>

            <div className="grid gap-4 sm:grid-cols-2 sm:gap-6">
              <div className="sm:col-span-2">
                <label
                  htmlFor="name"
                  className="mb-2 block text-sm font-medium text-gray-900 "
                >
                  Section
                </label>
                <input
                  type="text"
                  value={section.name}
                  name="name"
                  id="name"
                  onChange={handleInputSection}
                  className="focus:ring-primary-600 focus:border-primary-600  block w-full rounded-lg border border-gray-300 bg-gray-50 p-2.5 text-sm text-gray-900   "
                  placeholder="Section name"
                  required
                />
              </div>
              <div className="relative w-full lg:max-w-sm">
                <label
                  className="block mb-2 text-sm font-medium text-gray-900"
                  htmlFor="user_avatar"
                >
                  Select shop
                </label>
                <select
                  onChange={(event) => handleChangeShop(event.target.value)}
                  value={section.subcategory_id}
                  className="w-full p-2.5 text-gray-500 bg-white border rounded-md shadow-sm outline-none appearance-none focus:border-indigo-600"
                >
                  {shops &&
                    shops.length > 0 &&
                    shops.map((shop) => (
                      <option key={shop.id} value={shop.id}>
                        {shop.name}
                      </option>
                    ))}
                </select>
              </div>

              <div className="text-center">
                <button
                  onClick={apiCall}
                  type="submit"
                  className="bg-gray-900 focus:ring-white hover:bg-primary-800 mt-4 inline-flex items-center rounded-lg px-5 py-2.5 text-center text-sm font-medium text-white focus:ring-4  sm:mt-6"
                >
                  Edit section
                </button>
              </div>
            </div>
          </div>
        </section>
      )}
    </div>
  );
};

export default EditSection;
